import pino from 'pino';

const logger = pino({
  name: 'Askademia web app',
  level: 'info'
})

export default logger;